const PNP_REFRESH_V1 = 'GROW-2792';
const TYPE_DESCRIPTION = '[Type: String][Vis.: high] - ';
const EXPERIMENT_DESCRIPTION = ' - A string in pricing experiment GROW-2792';
const CATEGORY = 'category heading';

const experimentCategoryCopy = {
  grow_2792_team_collaboration: {
    id: 'Pricing.experimentCategoryCopy.TeamCollaboration',
    defaultMessage: 'Team Collaboration with 3+ users',
    desc: {
      id: 'Pricing.experimentCategoryCopy.TeamCollaboration',
      message: `${TYPE_DESCRIPTION} ${CATEGORY} label ${EXPERIMENT_DESCRIPTION} (new)`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_team_management: {
    id: 'Pricing.experimentCategoryCopy.TeamManagement',
    defaultMessage: 'Team Management with 3+ users',
    desc: {
      id: 'Pricing.experimentCategoryCopy.TeamManagement',
      message: `${TYPE_DESCRIPTION} ${CATEGORY} label ${EXPERIMENT_DESCRIPTION} (new)`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_form_survey_capabilities: {
    id: 'Pricing.experimentCategoryCopy.FormSurveyCapabilities',
    defaultMessage: 'Form & Survey Capabilities',
    desc: {
      id: 'Pricing.experimentCategoryCopy.FormSurveyCapabilities',
      message: `${TYPE_DESCRIPTION} ${CATEGORY} label ${EXPERIMENT_DESCRIPTION} (new)`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_survey_builder: {
    id: 'Pricing.experimentCategoryCopy.FormSurveyBuilder',
    defaultMessage: 'Form & Survey Builder',
    desc: {
      id: 'Pricing.experimentCategoryCopy.FormSurveyBuilder',
      message: `${TYPE_DESCRIPTION} ${CATEGORY} label ${EXPERIMENT_DESCRIPTION} (new)`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_enterprise_grade_security: {
    id: 'Pricing.categoryCopy.EnterpriseGradeSecurity',
    defaultMessage: 'Enterprise-grade Admin and Security',
    desc: {
      id: 'Pricing.categoryCopy.EnterpriseGradeSecurity',
      message: `${TYPE_DESCRIPTION} ${CATEGORY} label ${EXPERIMENT_DESCRIPTION} (new)`,
      project: PNP_REFRESH_V1,
    },
  },
};

export default experimentCategoryCopy;
